import ProductCard from "components/Product";
import AccessoryItem from "features/accessories/components/AccessoryItem";
import { ObjectType } from "features/types";
import React from "react";
import styled from "styled-components";

interface SearchCardProps {
  item: any;
}

const SearchCard: React.FC<SearchCardProps> = ({ item }) => {
  const renderCard = (item: any) => {
    switch (item.objectType) {
      case ObjectType.accessory:
        return <AccessoryItem item={item} />;
      case ObjectType.product:
        return <ProductCard item={item} />;
    }
  };
  return <>{renderCard(item)}</>;
};

const SearchCardContainer = styled.div``;

export default SearchCard;
